import { usePaginatedApi } from "../../../swr/useApi";
import { adminChangeRequestsService } from "../../api_client";
import type { ChangeRequestDto, DocumentsQueryDto } from "../../../api";
import { DocumentsQueryDtoStatusEnum } from "../../../api";

export function useAdminDashboardChangeRequests() {
  return usePaginatedApi<ChangeRequestDto, DocumentsQueryDto>({
    key: "admin-dashboard-change-requests",
    serviceMethod: async (query) =>
      adminChangeRequestsService.adminListChangeRequests(query),
    query: { status: DocumentsQueryDtoStatusEnum.Pending, page: 1, pageSize: 3 },
  });
}
